import { useRef } from 'react';
import terms from './alphaTerms.json';
import './AlphaTerms.css';

export default function AlphaTerms({ accepted, onChange }) {
  const dialog = useRef(null);
  return (
    <>
      <div className="alpha-terms-row">
        <label>
          <input type="checkbox" required checked={accepted} onChange={event => onChange(event.target.checked)} />
          Agree to alpha ToS
        </label>
        <button className="alpha-terms-link" type="button" onClick={() => dialog.current?.showModal()}>Read terms</button>
      </div>
      <dialog ref={dialog} className="alpha-terms-dialog" aria-label="Alpha terms">
        <h2>Alpha terms</h2>
        <p>{terms.heading}</p>
        <ul>{terms.bullets.map(bullet => <li key={bullet}>{bullet}</li>)}</ul>
        <button type="button" onClick={() => dialog.current?.close()}>Close terms</button>
      </dialog>
    </>
  );
}
